module.exports = __webpack_public_path__ + "static/media/press_kit.eeb01e87.svg";